<section class="pbw-panel">
  <h2 class="pbs-title">Esto es lo que trae el archivo</h2>
  <p class="pbs-lead">Todavía no existe ningún pago. Revisa las cifras y decide qué hacer con ellas.</p>

  <div class="pbs-summary">
    <div class="pbs-stat is-ok">
      <div class="pbs-stat-v">{{ state.parse?.readyCount || 0 }}</div>
      <div class="pbs-stat-l">Listas para registrar</div>
    </div>
    <div class="pbs-stat">
      <div class="pbs-stat-v">{{ state.parse?.totalAmount || 0 | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</div>
      <div class="pbs-stat-l">Suma de lo que entra</div>
    </div>
    <div class="pbs-stat is-warn" *ngIf="state.parse?.duplicateCount">
      <div class="pbs-stat-v">{{ state.parse?.duplicateCount }}</div>
      <div class="pbs-stat-l">Posibles duplicados</div>
    </div>
    <div class="pbs-stat is-danger" *ngIf="state.parse?.errorCount">
      <div class="pbs-stat-v">{{ state.parse?.errorCount }}</div>
      <div class="pbs-stat-l">No se pueden registrar</div>
    </div>
  </div>

  <!-- El guardia anti-recarga vive en el alta; su respuesta se adelanta aquí para que nadie llegue al
       punto de no retorno solo para que se lo rechacen. -->
  <div class="pbs-notice is-danger" *ngIf="yaCargado">
    <i class="fa-solid fa-rotate-left" aria-hidden="true"></i>
    <div>
      <strong>Este archivo ya se cargó</strong>
      {{ state.parse?.alreadyLoaded }} de sus pagos están registrados. Si vas a corregir las filas que fallaron, sube un
      archivo <em>solo con ellas</em>: volver a subir el archivo completo duplicaría los que ya entraron.
    </div>
  </div>

  <div class="pbs-notice" *ngIf="hayProblemas && !yaCargado">
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <div>
      <strong>Las filas marcadas no se van a registrar</strong>
      El resto sí. Puedes seguir y corregirlas en un archivo aparte, o arreglar la hoja y volver a leerla.
    </div>
  </div>

  <!-- El interruptor de D6: es lo que decide si el asistente son tres pasos o seis. -->
  <fieldset class="pbs-mode" [disabled]="state.registered">
    <legend>¿Qué se hace con estos pagos?</legend>
    <label class="pbs-mode-opt" *ngFor="let m of modos" [class.is-on]="state.mode === m.value">
      <input type="radio" name="pbwMode" [value]="m.value" [checked]="state.mode === m.value" (change)="cambiarModo(m.value)" />
      <span>
        <strong>{{ m.label }}</strong>
        <em>{{ m.hint }}</em>
      </span>
    </label>
  </fieldset>

  <div class="pbs-filter">
    <p-checkbox [(ngModel)]="soloProblemas" [binary]="true" inputId="pbwSoloProblemas"></p-checkbox>
    <label for="pbwSoloProblemas">Ver solo las filas con problema</label>
    <span class="pbs-hint">{{ rows.length }} de {{ state.parse?.totalRows || 0 }}</span>
  </div>

  <div class="pbs-table-wrap">
    <table class="pbs-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th>RFC</th>
          <th class="num">Monto</th>
          <th>Pagó el</th>
          <th>Cuenta</th>
          <th>Destino</th>
          <th>Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let r of rows" [class]="claseFila(r)">
          <td>{{ r.rowNumber }}</td>
          <td>{{ r.clientName || '—' }}</td>
          <td>{{ r.rfc }}</td>
          <td class="num">{{ r.amount | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}</td>
          <td>{{ r.date ? (r.date | date: 'dd/MM/yyyy') : '—' }}</td>
          <td>{{ r.accountAlias || '—' }}</td>
          <td>{{ destinos(r) }}</td>
          <td>
            <span class="enf-chip" *ngIf="r.status === 'LISTA'" style="background: rgba(15, 123, 63, 0.12); color: #0f7b3f">Lista</span>
            <span class="enf-chip" *ngIf="r.status === 'POSIBLE_DUPLICADO'">Posible duplicado</span>
            <span class="enf-chip is-danger" *ngIf="r.status === 'ERROR'">No se registra</span>
            <div class="pbs-row-msg" *ngIf="r.message">{{ r.message }}</div>
          </td>
        </tr>
        <tr *ngIf="!rows.length">
          <td colspan="8" class="pbs-hint">No hay filas que enseñar con este filtro.</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!--
    El punto de no retorno, pegado a las cifras que confirma.

    Tenía una pantalla propia que repetía estas mismas cuatro cifras en forma de lista para pedir
    una casilla. Lo que valía de ella —el aviso de que esto no se deshace— baja aquí; lo que
    repetía, se fue.
  -->
  <div class="pbs-commit" *ngIf="puedeSeguir">
    <p-checkbox [(ngModel)]="confirmado" [binary]="true" inputId="pbwConfirmarAlta"></p-checkbox>
    <label for="pbwConfirmarAlta">
      <strong>
        Revisé las cifras: crear {{ state.parse?.readyCount || 0 }} pago(s) por
        {{ state.parse?.totalAmount || 0 | currency: 'MXN' : 'symbol-narrow' : '1.2-2' }}
      </strong>
      <em>
        Una vez creados, sacarlos de circulación es otro trabajo: se anulan uno por uno desde «Por atender», con motivo
        y bitácora.
        {{ state.mode === 'SOLO_ALTA' ? 'Después quedan sin aplicar.' : 'Después eliges destinos y aplicas.' }}
      </em>
    </label>
  </div>

  <div class="pbs-error" *ngIf="error">
    <i class="fa-solid fa-circle-exclamation" aria-hidden="true"></i>
    <span>{{ error }}</span>
  </div>

  <div class="pbs-actions">
    <button pButton type="button" label="Salir" class="p-button-text p-button-secondary pbs-left" [disabled]="registrando" (click)="onExit.emit()"></button>
    <button pButton type="button" label="Cambiar de archivo" icon="fa-solid fa-chevron-left" class="p-button-outlined" [disabled]="registrando" (click)="onBack.emit()"></button>
    <button
      pButton
      type="button"
      [label]="'Registrar ' + (state.parse?.readyCount || 0) + ' pago(s)'"
      icon="fa-solid fa-floppy-disk"
      [disabled]="!puedeRegistrar"
      [loading]="registrando"
      (click)="registrar()"
    ></button>
  </div>
</section>
